import * as angular from 'angular';

import { ComponentDefinition, IValueViewModel, TagDefinitionVm } from '../../models/';
import { INavigationHistoryService } from '../../services/';

class TagAttributesController implements angular.IComponentController {
    readonly tagViewModel: TagDefinitionVm;

    static $inject = ['$state', '$translate', 'navigationHistoryService'];

    constructor(
        private _$state: angular.ui.IStateService,
        private _$translate: angular.translate.ITranslateService,
        private _navigationHistoryService: INavigationHistoryService
    ) {
    }

    $onInit() {
        this.refresh();
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        this.refresh();
    }

    private updateName(name: string) {
        const translated = `${this._$translate.instant(this._$state.current.data.displayName)} - ${name}`;
        this._navigationHistoryService.updateLastHistory(translated, 'tag.');
    }

    private refresh() {
        if (this.tagViewModel) {
            this.updateName(this.tagViewModel.name);
        }
    }

    getComment(tag: IValueViewModel): string {
        return tag?.longComment
            ?? tag?.shortComment
            ?? '-';
    }
}

export const wtTagAttributes: ComponentDefinition = {
    componentId: 'wtTagAttributes',
    controller: TagAttributesController,
    template: require('./tagAttributes.component.html'),
    controllerAs: 'vm',
    bindings: {
        tagViewModel: '<'
    }
};